import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { AiOutlineMail } from 'react-icons/ai';
import { BsMailbox } from 'react-icons/bs';
import { BiSupport } from 'react-icons/bi';
import { MdFax, MdOutlineCall } from 'react-icons/md';
import informalImage from './informal.png';
import useAuth from '../hooks/useAuth';
import Dashboard from './console/Dashboard';

function Home() {
  const title = 'Member Portal';
  const { getSession } = useAuth();
  const navigate = useNavigate();
  const user = getSession();
  if (user) {
    return (
      <Dashboard />
    );
  }
  const style = { color: '#962c30', fontSize: '1.3em' };
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <main className="container">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item active>Welcome</Breadcrumb.Item>
        </Breadcrumb>
        <h1 className="page-title">{title}</h1>
        <Row>
          <Col lg="6">
            <div className="card">
              <div className="card-header">
                Member Portal
              </div>
              <div className="card-body">
                <p className="text-justify">
                  Welcome to Member Self Service Portal. Enjoy our online services anywhere.
                  Register and get an Online Account access to personal details and enquire
                  status for contributions and claims.
                </p>
                <p className="text-justify">
                  To create Online Account, a member is required to have Member Id, Email Address and Mobile Number.
                  For security purpose account details including password, are secret to member,
                  and no other person should know these details.
                </p>
                <div className="mb-2">
                  <Row>
                    <Col>
                      <button type="button"
                              className="btn btn-green btn-block"
                              onClick={() => navigate('/signup')}
                      >
                        Register
                      </button>
                    </Col>
                    <Col>
                      <button type="button"
                              className="btn btn-green btn-block"
                              onClick={() => navigate('/login')}
                      >
                        Log in
                      </button>
                    </Col>
                  </Row>
                </div>
                <strong>Verify</strong>
                <p>If you have Received Verification SMS, click on button below to start account
                  verification with mobile number.</p>
                <p>
                  <button type="button"
                          className="btn btn-green btn-block px-4 gap-3"
                          onClick={() => navigate('/verify')}
                  >
                    Verify Account
                  </button>
                </p>
              </div>
            </div>
          </Col>
          <Col lg="6">
            <div className="card">
              <img src={informalImage} alt="" className="card-image"/>
              <div className="card-header">
                Support
              </div>
              <div className="card-body">
                <p className="text-justify">
                  Our customers and stakeholders can contact with us via;
                </p>
                <Row>
                  <Col lg="6">
                  <p className="text-justify">
                    <AiOutlineMail style={style}/> customercare@nssf.go.tz
                  </p>
                  <p className="text-justify">
                    <BsMailbox style={style}/> P.O.Box 1322 DSM,Tanzania
                  </p>
                  </Col>
                  <Col lg="6">
                    <p className="text-justify">
                      <BiSupport style={style}/> 0800 116 773
                    </p>
                    <p className="text-justify">
                      <MdFax style={style}/> (255) (22) 2200037
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <p className="text-justify">
                      <MdOutlineCall style={style}/> (255) (22) 2163400-19 or (255) (75) 6140140
                    </p>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </main>
    </>
  );
}

export default Home;
